// eslint-disable-next-line jira/import/no-anonymous-default-export
export default {
	get(): boolean {
		return true;
	},
};
